/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspacePermission
 */
export interface WorkspacePermission {
    /**
     * 
     * @type {number}
     * @memberof WorkspacePermission
     */
    id: number;
    /**
     * 
     * @type {ElementsUserReference}
     * @memberof WorkspacePermission
     */
    user?: ElementsUserReference;
    /**
     * 
     * @type {ElementsGroupReference}
     * @memberof WorkspacePermission
     */
    group?: ElementsGroupReference;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspacePermission
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspacePermission
     */
    workspace: number;
}

export function WorkspacePermissionFromJSON(json: any): WorkspacePermission {
    return WorkspacePermissionFromJSONTyped(json, false);
}

export function WorkspacePermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspacePermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': !exists(json, 'user') ? undefined : ElementsUserReferenceFromJSON(json['user']),
        'group': !exists(json, 'group') ? undefined : ElementsGroupReferenceFromJSON(json['group']),
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'workspace': json['workspace'],
    };
}

export function WorkspacePermissionToJSON(value?: WorkspacePermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': ElementsUserReferenceToJSON(value.user),
        'group': ElementsGroupReferenceToJSON(value.group),
        'read_only': value.readOnly,
        'workspace': value.workspace,
    };
}


